import PropTypes from "prop-types";
import React from "react";
import ReactDOM from "react-dom";
import Gallery from "react-grid-gallery";

class CarGallery extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      images: this.props.images
    };
  }

  render() {
    return (
      <div
        style={{
          display: "block",
          minHeight: "1px",
          width: "90%",
          border: "0",
          overflow: "auto",
          marginLeft: "5%",
          marginTop: "25px",
          marginBottom: "25px"
        }}
      >
        <Gallery
          images={this.state.images}
          enableLightbox={true}
          enableImageSelection={false}
        />
      </div>
    );
  }
}

CarGallery.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string.isRequired,
      thumbnail: PropTypes.string.isRequired,
      srcset: PropTypes.array,
      caption: PropTypes.string,
      thumbnailWidth: PropTypes.number.isRequired,
      thumbnailHeight: PropTypes.number.isRequired
    })
  ).isRequired
};

CarGallery.defaultProps = {
  images: [
    {
      src: "/img/cars/gallery/corolla/1.jpg",
      thumbnail: "/img/cars/gallery/corolla/1.jpg",
      thumbnailWidth: 320,
      thumbnailHeight: 174
    },
    {
      src: "/img/cars/gallery/corolla/2.jpg",
      thumbnail: "/img/cars/gallery/corolla/2.jpg",
      thumbnailWidth: 320,
      thumbnailHeight: 174
    },
    {
      src: "/img/cars/gallery/corolla/3.jpg",
      thumbnail: "/img/cars/gallery/corolla/3.jpg",
      thumbnailWidth: 320,
      thumbnailHeight: 174
    },
    {
      src: "/img/cars/gallery/corolla/4.jpg",
      thumbnail: "/img/cars/gallery/corolla/4.jpg",
      thumbnailWidth: 320,
      thumbnailHeight: 174
    },
    {
      src: "/img/cars/gallery/corolla/5.jpg",
      thumbnail: "/img/cars/gallery/corolla/5.jpg",
      thumbnailWidth: 320,
      thumbnailHeight: 174
    },
    {
      src: "/img/cars/gallery/corolla/6.jpg",
      thumbnail: "/img/cars/gallery/corolla/6.jpg",
      thumbnailWidth: 320,
      thumbnailHeight: 174
    },

    {
      src: "/img/cars/gallery/corolla/7.jpg",
      thumbnail: "/img/cars/gallery/corolla/7.jpg",
      thumbnailWidth: 320,
      thumbnailHeight: 174
    },
    {
      src: "/img/cars/gallery/corolla/8.jpg",
      thumbnail: "/img/cars/gallery/corolla/8.jpg",
      thumbnailWidth: 320,
      thumbnailHeight: 174
    }
  ]
};

export default CarGallery;
